import { Component, ViewChild } from '@angular/core';
import { LoadingController, NavController, NavParams } from 'ionic-angular';
import { Globals } from "../../../../../globals";
import { CartaServices } from '../../../services';
import { TranslateService } from '@ngx-translate/core';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
/**
 * Generated class for the CartaPartialDishProdSelectedPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-carta-partial-dish-prod-selected',
    templateUrl: 'carta-partial-dish-prod-selected.html',
})
export class CartaPartialDishProdSelectedPage {
    //datatable
    sorts = [
        { prop: 'name', dir: 'asc' }
    ];
    @ViewChild(DatatableComponent) table: DatatableComponent;
    ColumnMode = ColumnMode;
    config_msg = {
        emptyMessage: this.translate.instant('general-no-hay-datos'),
        totalMessage: this.translate.instant('general-total'),
        selectedMessage: this.translate.instant('general-seleccionado')
    };

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public loadingCtrl: LoadingController,
        public globals: Globals,
        public cartaServices: CartaServices,
        public translate: TranslateService) {
    }

    deleteElement(index) {
        if (index >= 0) {
            this.cartaServices.carta_dish_prod_array_tmp.splice(index, 1);
            this.cartaServices.carta_dish_prod_array_tmp = [...this.cartaServices.carta_dish_prod_array_tmp];
        }
    }

    reorderElements(indexes) {
        var element = this.cartaServices.carta_dish_prod_array_tmp[indexes.from];
        this.cartaServices.carta_dish_prod_array_tmp.splice(indexes.from, 1);
        this.cartaServices.carta_dish_prod_array_tmp.splice(indexes.to, 0, element);
    }

}



// WEBPACK FOOTER //
// ./src/pages/carta/carta-create/carta-create-dish-prod-select/carta-partial-dish-prod-selected/carta-partial-dish-prod-selected.ts